/**
 * Overlay component that visually marks a rate as no longer available by dimming it. The card says why
 * itself: its red "Sold out" button sits above the dimming.
 */

import { cn } from '@elara/client-core/lib/utils';

interface UnavailableOverlayProps {
  children: React.ReactNode;
  className?: string;
}

export function UnavailableOverlay({ children, className }: UnavailableOverlayProps) {
  return (
    <div className={cn('relative is-unavailable rounded-md overflow-hidden', className)}>
      {children}
      <div className="absolute inset-0 z-[5] bg-background/60 pointer-events-none"></div>
    </div>
  );
}
